// Bootstrap
require('./bootstrap');

// Slick
require('slick-carousel');
require('slick-lightbox');

require('jquery.easing');
require('./jquery.isonscreen.min');

// Instafeed.js
/*import Instafeed from 'instafeed.js';
window.Instafeed = Instafeed;*/

/* New Lazyload  */
import lazySizes from 'lazysizes';
lazySizes.cfg.expand = 300;

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));
    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};


let resizeTimer;
$(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        equalHeights();
    }, 100);
});


function countUp(facts_scrolled) {
    $('.countUp').each(function () {
        if (facts_scrolled[$(this).attr('data-countid')] === undefined && $(this).isOnScreen()) {

            let $this = $(this),
                countTo = $this.attr('data-count');
            // let n = (countTo - Math.floor(countTo) !== 0) ? 1 : 0;
            let n = (countTo.toString().split('.')[1] || '').length;

            // console.log((parseFloat(countTo).toString().split('.')[1] || '').length);

            $({countNum: 0}).animate({
                    countNum: countTo
                },
                {
                    duration: Math.floor(Math.random() * 5000) + 3000,
                    easing: 'easeOutQuad',
                    step: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    },
                    complete: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    }
                });
        }

    });
}

let facts_scrolled = [];

$(window).on('scroll', function (e) {
    countUp(facts_scrolled);
});

$(window).on('load', function (e) {
    countUp(facts_scrolled);
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("div.sticky-header--desktop-navigation ul.navigation--main");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("a.card-image");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});

$(document).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll > 27) {
        $("#sticky-header").addClass("scrolled");
        $("body").addClass("scrolling");
    } else {
        $("#sticky-header").removeClass("scrolled");
        $("body").removeClass("scrolling");
    }
});

$(document).click(function(e) {
    var $target = $(e.target);
    if(
        !$target.closest('.navigation--mobile').length && !$target.hasClass('navigation--mobile') &&
        !$target.closest('.btn-nav').length && !$target.hasClass('btn-nav')) {

        if($('.navigation--mobile').hasClass('active')) {
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
            $('.navigation--mobile').removeClass('active');
            $('.header-nav-container').removeClass('mobile-nav-active');
        }
    }
});

$(document).ready(function() {

    const hero_slider = document.getElementById('hero') || false;

    if (hero_slider) {
        $('#sticky-header').addClass('drop-shadow');
    }

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        var screen = $(window).height();

        // show 'go up' and add pageEnd class
        if (scroll > screen) {
            $('.go-up').addClass('shown')
        } else {
            $('.go-up').removeClass('shown')
        }
    });

    $('.go-up').on('touchstart, click', function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
    });

/*    window.addEventListener('click', function(e){
        if (document.getElementById('sticky-background').contains(e.target)){
            // Clicked in box
            console.log('in box');
        } else {
            if($('#sticky-nav--container').hasClass('active')) {
                console.log('honk');
                /!*$('.btn-nav').removeClass('active');
                $('body').removeClass('nav-overflow');
                $('#sticky-nav--container').removeClass('active');
                $('#sticky-body').removeClass('active');*!/
            }
        }
    });*/

/*    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        var screen = $(window).height();

        if (scroll > screen / 2) {
            $('.sticky-cart').addClass('shown')
        } else {
            $('.sticky-cart').removeClass('shown')
        }
    });*/

    //equalHeights();

    $('.loading-page').show();
    countUp(facts_scrolled);

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        let link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    if ($(window).width() >= 992) {
        $('ul.navigation--main li.parentnav').on("touchstart", function (e) {
            'use strict'; //satisfy code inspectors
            var link = $(this); //preselect the link
            if (link.hasClass('hover')) {
                return true;
            }
            else {
                link.addClass('hover');
                $('ul.navigation--main li.parentnav').not(this).removeClass('hover');
                e.preventDefault();
                return false; //extra, and to make sure the function has consistent return points
            }
        });
    }

    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('.navigation--mobile').hasClass('active')) {
            $('.navigation--mobile').removeClass('active');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
            $('.header-nav-container').removeClass('mobile-nav-active');
        } else {
            $('.navigation--mobile').addClass('active');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');
            $('.header-nav-container').addClass('mobile-nav-active');
        }
    });

    $('.toggle-cart-button').on('click', function(e) {
        e.preventDefault();
        if($('#cart-sidebar').hasClass('active')) {
            $('body').removeClass('nav-overflow');
        } else {
            $('body').addClass('nav-overflow');
        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    $(window).resize(function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $(window).on('orientationchange', function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption'
    });


    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        let el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });

    window.livewire.onError(statusCode => {
        if (statusCode === 419 || statusCode === 404 || statusCode === 500) {
            return false
        }
    });

});

function checkGrid() {
    if ($(window).width() >= 1200) return 'XL';
    if ($(window).width() >=  992) return 'LG';
    if ($(window).width() >=  768) return 'MD';
    if ($(window).width() >=  576) return 'SM';
    return 'XS';
}

function setEqualHeights(children) {
    let fixedHeight = 0;
    children.each(function (i, c) {
        $(c).attr('style', ''); // reset
        let height = $(c).outerHeight();
        if ( height > fixedHeight ) {
            fixedHeight = height;
        }
    });

    children.each(function (i, c) {
        $(c).css({'height': fixedHeight + "px"});
    });
}

window.equalHeights = function() {
    let check = checkGrid();
    // console.log(check);

    if (check !== 'XS') {

        // console.log($('.eqh-parent'));
        $('.eqh-parent').each(function () {
            let highestBox = 0;
            let highestTitle = 0;
            let highestImage = 0;
            let highestText = 0;
            let highestSubtitle = 0;
            let highestPrice = 0;
            let highestBtn = 0;

            $(this).find('.eq-title-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestTitle = $(this).outerHeight();
                }
            });
            $(this).find('.eq-title-height').css({'height': highestTitle + "px"});

            $(this).find('.eq-subtitle-height').each(function () {
                if ($(this).outerHeight() > highestSubtitle) {
                    highestSubtitle = $(this).outerHeight();
                }
            });
            $(this).find('.eq-subtitle-height').css({'height': highestSubtitle + "px"});

            $(this).find('.eq-price-height').each(function () {
                if ($(this).outerHeight() > highestPrice) {
                    highestPrice = $(this).outerHeight();
                }
            });
            $(this).find('.eq-price-height').css({'height': highestPrice + "px"});

            $(this).find('.eq-image-height').each(function () {
                if ($(this).outerHeight() > highestImage) {
                    highestImage = $(this).outerHeight();
                }
            });
            $(this).find('.eq-image-height').css({'height': highestImage + "px"});

            $(this).find('.eq-text-height').each(function () {
                if ($(this).outerHeight() > highestText) {
                    highestText = $(this).outerHeight();
                }
            });
            $(this).find('.eq-text-height').css({'height': highestText + "px"});

            $(this).find('.eq-btn-height').each(function () {
                if ($(this).outerHeight() > highestBtn) {
                    highestBtn = $(this).outerHeight();
                }
            });
            $(this).find('.eq-btn-height').css({'height': highestBtn + "px"});


            $(this).find('.eq-box-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestBox = $(this).outerHeight();
                }
            });
            $(this).find('.eq-box-height').css({'height': highestBox + "px"});

        });
    }
};



// WEBPACK FOOTER //
// ./resources/js/frontend.js